export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/google_earth_pro.a7437d7.svg";